<!--
  view-logged-item.component.html

  Read-only detail page for a single logged receiving item, reached by scanning
  the item's QR code. Three states: loading spinner, the item + parent-log
  facts card, and a not-found/error card. Phase 2 status actions will slot in
  below the facts card.
-->
<ion-content class="vli-content">

  <!-- Loading -->
  <div *ngIf="state === 'loading'" class="vli-center spinner-container">
    <ion-spinner name="crescent"></ion-spinner>
    <div class="vli-muted">Looking up item…</div>
  </div>

  <!-- Not found -->
  <div *ngIf="state === 'notFound'" class="vli-center">
    <ion-icon name="help-circle-outline" class="vli-state-icon"></ion-icon>
    <div class="vli-state-title">Item not found</div>
    <div class="vli-muted">
      This QR code doesn't match a logged item. It may have been removed, or the
      link is incomplete — try rescanning the label.
    </div>
  </div>

  <!-- Error -->
  <div *ngIf="state === 'error'" class="vli-center">
    <ion-icon name="alert-circle-outline" class="vli-state-icon vli-state-icon-error"></ion-icon>
    <div class="vli-state-title">Couldn't load this item</div>
    <div class="vli-muted">Something went wrong fetching the item details.</div>
    <button class="vli-retry-btn" (click)="fetchItem()">
      <ion-icon name="refresh-outline"></ion-icon>
      Try again
    </button>
  </div>

  <!-- Loaded -->
  <ng-container *ngIf="state === 'loaded' && detail">

    <!-- Header: item identity + position -->
    <div class="vli-header">
      <div class="vli-header-eyebrow">Logged item</div>
      <div class="vli-header-title">{{ positionLine }}</div>
      <div class="vli-header-subtitle" *ngIf="detail.item.poNumber">PO {{ detail.item.poNumber }}</div>
    </div>

    <!-- Item + log facts -->
    <div class="vli-card">
      <div class="vli-row" *ngFor="let row of rows">
        <span class="vli-row-label">{{ row.label }}</span>
        <span class="vli-row-value" [class.vli-mono]="row.mono">{{ row.value }}</span>
      </div>
    </div>

    <!-- Receipt ledger: what physically arrived on this delivery -->
    <div class="vli-card vli-receipts" *ngIf="detail.receipts?.length">
      <div class="vli-receipts-title">Received on this delivery</div>
      <div class="vli-receipt-row" *ngFor="let receipt of detail.receipts">
        <div class="vli-receipt-main">
          <span class="vli-receipt-line">{{ receiptLineLabel(receipt) }}</span>
          <span class="vli-receipt-desc">{{ receipt.itemDescription }}</span>
        </div>
        <div class="vli-receipt-meta">
          <span *ngIf="receipt.quantityReceived != null" class="vli-mono">
            ×{{ receipt.quantityReceived }} {{ receipt.unitOfMeasure }}
          </span>
          <span *ngIf="receipt.receiptStatus"
                class="vli-receipt-status"
                [class.vli-receipt-partial]="receipt.receiptStatus === 'Partial'">
            {{ receipt.receiptStatus }}
          </span>
        </div>
      </div>
    </div>

    <!-- Parent log gone (item row outlived it) -->
    <div class="vli-card vli-log-missing" *ngIf="!detail.log">
      <ion-icon name="information-circle-outline"></ion-icon>
      <span>The receiving log this item belongs to is no longer available.</span>
    </div>

    <!-- Phase 2: status history + actions mount here -->

  </ng-container>

</ion-content>
